module.exports = __webpack_public_path__ + "fonts/poppins-regular-webfont.e369c41b.woff2";